import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

export const useDeleteCustomMetricsDataSourceMutation = () => {
  return useMutation({
    mutationFn: apiClient.workloadOptimization.deleteCustomMetricsDataSource,
  });
};
